import { LuMenu } from "react-icons/lu";
import { Helmet } from "react-helmet";
import { useIsUserSignedIn } from "../../core_stores/useAuthStore";
import {
  useIsSideMenuOpen,
  useSideMenuActions,
} from "../../view_stores/useSideMenuStore";
import { WelcomeAppBar } from "./components/WelcomeAppBar";
import { WelcomeDescription } from "./components/WelcomeDescription";
import { WelcomeFooter } from "./components/WelcomeFooter";
import WelcomeFreeToTryInfo from "./components/WelcomeFreeToTryInfo";
import { WelcomeBlogFeed } from "./components/WelcomeBlogFeed";
import { WelcomeTextField } from "./components/WelcomeTextField";
import { WelcomeSEOText } from "./components/WelcomeSEOText";
import { WelcomeAnnouncementBanner } from "./components/WelcomeAnnouncementBanner";
import { spacing, layout, colors } from "../../design/tokens";

export function WelcomePageCompact() {
  const { open: openSideMenu, close: closeSideMenu } = useSideMenuActions();
  const isSideMenuOpen = useIsSideMenuOpen();
  const isUserSignedIn = useIsUserSignedIn();

  return (
    <>
      <Helmet>
        <title>Text to Mobile App - Darvin AI-Powered Flutter App Builder</title>
      </Helmet>
      <div className="flex flex-col min-h-[100dvh] min-w-[350px]">
      <WelcomeAnnouncementBanner />
      <div className="relative min-h-[70vh] bg-gradient-hero-dark">
        <div className={`${layout.position.relative} h-full flex flex-col`}>
          {/* <WelcomePromoCode /> */}
          <div className={`flex flex-row items-center ${layout.container.fullWidth}`}>
            {isUserSignedIn && (
              <div className="pl-4">
                <LuMenu
                  size={34}
                  onClick={isSideMenuOpen ? closeSideMenu : openSideMenu}
                  className={`cursor-pointer ${colors.text.primary}`}
                />
              </div>
            )}
            <WelcomeAppBar />
          </div>
          <div className={`flex-1 flex flex-col items-center justify-center px-4 pt-16 pb-24 ${spacing.gap.lg}`}>
            <WelcomeDescription />
            <WelcomeTextField />
            <WelcomeFreeToTryInfo />
          </div>
        </div>
        {/* Fade overlay to smoothly transition to blog section */}
        <div className={`${layout.position.absolute} bottom-0 left-0 right-0 h-64 pointer-events-none bg-gradient-to-b from-transparent via-dark-surface-primary/60 to-dark-surface-primary ${layout.zIndex.base}`} />
      </div>
      <div className={colors.surface.primary}>
        <div className={`px-8 py-4 ${layout.container.fullWidth} ${spacing.maxWidth.content} ${layout.container.centered}`}>
          {/* <WelcomeTryOutIdeas /> */}
          <WelcomeBlogFeed />
        </div>
        <WelcomeSEOText />
      </div>
      <WelcomeFooter />
    </div>
    </>
  );
}
